<template>
  <div>
    <!-- <el-dialog :modal="false" fullscreen append-to-body :visible.sync="show"> -->
      <div>
        <h2>出访报告</h2>
        <div v-for="addForm in source">
          <el-card>
            <div>
              <el-form
                ref="dialogForm"
                :model="addForm"
                :rules="rules"
                label-width="140px"
                label-position="right"
              >
                <el-row>
                  <el-col>
                    <el-form-item label="出访报告标题：" prop="reportTitle">
                      {{ addForm.reportTitle }}
                    </el-form-item>
                  </el-col>
                  <el-col>
                    <el-form-item label="出访报告内容：" prop="reportContent">
                      <div class="text-hidden">
                        <div v-html="addForm.reportContent"></div>
                      </div>
                    </el-form-item>
                  </el-col>
                  <el-col>
                    <el-form-item label="附件：" prop="reportFile">
                      <template #label>
                        <span>附件</span>
                      </template>
                      <span
                        style="cursor: pointer;color: #66B1FF;"
                        class="file-name"
                        v-show="addForm.reportFile.fileName != ''"
                        @click="
                          handlePreviewFile(
                            addForm.reportFile.path,
                            addForm.reportFile.fileName
                          )
                        "
                        >{{ addForm.reportFile.fileName }}</span
                      >
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </div>
          </el-card>
          <el-card>
            <div slot="header">出访成果情况</div>
            <div>
              <el-form
                ref="dialogBtmForm"
                :model="addForm"
                :rules="btmRules"
                label-width="140px"
              >
                <el-col>
                  <el-form-item
                    label="出访任务："
                    class="row_item whole-line"
                    prop="task"
                  >
                    {{ addForm.visitTask }}
                  </el-form-item>
                </el-col>
                <el-col>
                  <el-form-item label="合同签约：" prop="signFlag">
                    <el-radio label="0" disabled v-model="addForm.signFlag"
                      >是</el-radio
                    >
                    <el-radio label="1" disabled v-model="addForm.signFlag"
                      >否</el-radio
                    >
                  </el-form-item>
                </el-col>
                <el-col>
                  <el-table
                    v-if="addForm.signFlag == 0"
                    :data="addForm.signData || []"
                    border
                    style="width: 100%"
                  >
                    <el-table-column prop="ownerUnitName" label="业主单位名称">
                    </el-table-column>
                    <el-table-column prop="projectName" label="项目名称">
                    </el-table-column>
                    <el-table-column prop="goalAmount"  >
                      <template slot="header" slot-scope="scope">
                        合同金额（万元）
                        <el-tooltip
                          class="item"
                          effect="dark"
                          content="根据签署日期汇率折算为人民币"
                          placement="top-start"
                        >
                          <i class="el-icon-warning-outline"></i>
                        </el-tooltip>
                      </template>
                    </el-table-column>
                    <el-table-column prop="remark" label="备注">
                    </el-table-column>
                  </el-table>
                </el-col>

                <el-col>
                  <el-form-item label="项目中标：" prop="targetFlag">
                    <el-radio label="0" disabled v-model="addForm.targetFlag"
                      >是</el-radio
                    >
                    <el-radio label="1" disabled v-model="addForm.targetFlag"
                      >否</el-radio
                    >
                  </el-form-item>
                </el-col>
                <el-col v-if="addForm.targetFlag == 0">
                  <el-table
                    :data="addForm.targetData || []"
                    border
                    style="width: 100%"
                  >
                    <el-table-column prop="ownerUnitName" label="业主单位名称">
                    </el-table-column>
                    <el-table-column prop="projectName" label="项目名称">
                    </el-table-column>
                    <el-table-column prop="goalAmount" >
                      <template slot="header" slot-scope="scope">
                        中标金额（万元）
                        <el-tooltip
                          class="item"
                          effect="dark"
                          content="根据签署日期汇率折算为人民币"
                          placement="top-start"
                        >
                          <i class="el-icon-warning-outline"></i>
                        </el-tooltip>
                      </template>
                    </el-table-column>
                    <el-table-column prop="remark" label="备注">
                    </el-table-column>
                  </el-table>
                </el-col>

                <el-col>
                  <el-form-item
                    label="其他成果："
                    class="row_item whole-line"
                    prop="otherResult"
                  >
                    {{ addForm.otherResult }}
                  </el-form-item>
                </el-col>
                <span class="remark">如：签署合作或框架性协议。</span>
                <el-col>
                  <el-form-item
                    label="下一步计划："
                    class="row_item whole-line"
                    prop="nextPlan"
                  >
                    {{ addForm.nextPlan }}
                  </el-form-item>
                </el-col>
                <el-col>
                  <el-form-item
                    class="row_item whole-line"
                    prop="requireSolve"
                  >
                  <template slot='label'>
                    <span v-html="'需要集团&nbsp;&nbsp;&nbsp;<br/>解决的事项：'"></span>
                  </template>
                  
                    <!-- label-width="180px" -->
                    {{ addForm.requireSolve }}
                  </el-form-item>
                </el-col>
                
              </el-form>
            </div>
          </el-card>
        </div>
        <!-- <div class="footer">
          <el-button @click="close">取消</el-button>
        </div> -->
      </div>
    <!-- </el-dialog> -->
  </div>
</template>

<script>
import LetterManagement from "@/api/foreign/foreign_licence_manage/LetterManagement.js";
import ItemApi from "@/api/setup";
import logs from "../foreign_abroad_exchange/components/operate_logs";
import { mapGetters } from "vuex";
const Api = new LetterManagement();
import imgFile from "../../components/img-file";

export default {
  name: "VisitReportEdit",
  // props: ["source"],
  data() {
    const validateReportFile = (rule, value, callback) => {
      // 检查path是否存在
      if (!value || !value.path || value.path.trim() === "") {
        callback(new Error("请上传附件"));
      } else {
        callback();
      }
    };
    return {
      // reportFile: { path: "", fileName: "" },
      source: [],
      show: false,
      signTableVisible: false,
      signTableData: [], // 合同签约表格数据
      chapterTableVisible: false,
      chapterTableData: [], // 项目中标表格数据

      cloneDom: null,
      textDom: null,
      textQueryDom: null,
      hiddenForm: {
        reportContent: ""
      },
      // TODO 团组中有党委书记、党支部书记、董事长、执行董事、党委副书记、总经理、纪委书记、纪委副书记、副总经理、总会计师职务的需要出访报告必填校验
      rules: {
        reportTitle: [
          { required: true, message: "请输入出访报告标题", trigger: "change" }
        ],
        reportContent: [
          { required: true, message: "请输入出访报告内容", trigger: "change" }
        ],
        // 附件
        reportFile: [
          // 附件校验规则
          {
            required: true,
            validator: validateReportFile,
            trigger: "change, blur"
          }
        ]
      },
      btmRules: {
        task: [{ required: true, message: "请选择合同签约", trigger: "blur" }],
        targetFlag: [
          { required: true, message: "请选择项目中标", trigger: "change" }
        ],
        signFlag: [
          { required: true, message: "请选择合同签约", trigger: "change" }
        ],
        nextPlan: [
          { required: true, message: "请输入下一步计划", trigger: "blur" }
        ],
        // otherResult: [
        //   { required: true, message: "请选择合同签约", trigger: "blur" }
        // ]
      }
    };
  },
  components: {
    logs,
    imgFile
  },
  computed: {
    ...mapGetters(["token"])
  },
  watch: {},
  mounted() { 
      if (this.$route.query.visitId) {
        this.loadData(this.$route.query.visitId);
      }
    },
  methods: {

    // 文件预览
    handlePreviewFile(filePath, fileName) {
      let src = `/share-foreign/commannex/viewAnnex?path=${filePath}&token=${this.token}`;
      if (fileName.match(/\.pdf$/) || fileName.match(/\.PDF$/)) {
        window.open(src);
      } else {
        this.$message("仅支持pdf类型文件的预览");
      }
    },

    loadData(visitId) {
      let itemApi = new ItemApi();
      let param = {
        itemInfoId: visitId
      };
      itemApi.getVisitReportByItemInfoId(param).then(v => {
        this.source = v.data.map(v => {
          const reportFile = {
            path: v.visitReportPath,
            fileName: v.visitReportPath ? v.visitReportPath.split("_")[1] : ""
          };
          v.reportFile = reportFile;

          const signData = [];
          const targetData = [];
          v.visitGoals.forEach(item => {
            if (item.goalType == 0) {
              signData.push(item);
            } else {
              targetData.push(item);
            }
          });
          v.signData = signData;
          v.targetData = targetData;
          return v;
        });
      });
    },
    goBack() {
      this.$emit("change");
      this.show = false;
    },
    close() {
      this.goBack();
    }
  }
};
</script>
<style lang="scss" scoped>
.text-hidden {
  ::v-deep p {
    text-indent: 2rem;
  }
}
h2 {
  text-align: center;
}
::v-deep .el-card {
  border: none;
}
::v-deep .el-card__header {
  padding: 0;
  border: none;
}

.el-card__header div {
  line-height: 35px;
  border-bottom: 2px solid #818181;
}
// 为附件校验错误添加样式
::v-deep .el-form-item__error {
  margin-left: 140px;
}
::v-deep .el-form-item__content {
  z-index: 1;
}

.remark {
  margin-left: 146px;
  position: relative;
  top: -10px;
  font-size: 14px;
}
.add-row {
  position: relative;
  top: -19px;
  width: 100%;
}
.footer {
  margin: 0 auto;
  width: 100%;
  text-align: center;
}
</style>
<style>
.is-fullscreen.el-dialog {
  max-height: calc(100%);
  max-width: calc(100%);
}
</style>
